import { apiGet, type QueryRecord } from './http-client';

/** Подмножество полей услуги для списка/карточки в виджете (GET /api/v1/services). */
export type ClientServiceListItem = {
  id: number;
  service_type_slug: string;
  name: string;
  duration_minutes: number;
  price: string;
  /** Пробная цена первого занятия (только для основных услуг). */
  trial_price?: number | null;
  /** Минимальная применимая цена при наличии ценовых правил («от …»). */
  price_from?: number | null;
  description: string | null;
  description_format: 'html' | 'markdown' | 'plain';
  is_active: boolean;
  payment_required: boolean;
  group_type: string;
  photo_url: string | null;
  cancellation_deadline_minutes: number | null;
};

export function fetchClientServices(params: {
  organizationId: number;
  branchId: number | null;
  accessToken: string | null;
  q?: string | null;
}): Promise<ClientServiceListItem[]> {
  const q: QueryRecord = {
    active_only: true,
    organization_id: params.organizationId
  };
  if (params.branchId != null) {
    q.branch_id = params.branchId;
  }
  if (params.q?.trim()) {
    q.q = params.q.trim();
  }
  return apiGet<ClientServiceListItem[]>('/api/v1/services', q, {
    accessToken: params.accessToken ?? undefined
  });
}
